/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowElbowUpRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M213.65723,85.65674l-48,48A8.0001,8.0001,0,0,1,152,128V88H72V224a8,8,0,0,1-16,0V80a8.00008,8.00008,0,0,1,8-8h88V32a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48A8,8,0,0,1,213.65723,85.65674Z" />
    </Svg>
  );
}

export default ArrowElbowUpRight;
